import { FETCH_ALL_CUSTOM_FIELD_CATEGORIES_SUCCESS } from '../types'

export default function isLoaded(state = false, { type }) {
  if (type === FETCH_ALL_CUSTOM_FIELD_CATEGORIES_SUCCESS) return true
  return state
}
